// extracted by mini-css-extract-plugin
export default {"TextEditor":"TextEditor_TextEditor__Knioa","div":"TextEditor_div__lLd3e"};